import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect, useSelector } from 'react-redux'
import { useParams } from "react-router";
import { bltReviewSelect } from '../../../redux/selector/bltReviewSelector'
import {
    BLTNavigationTop,
    BLTScreenNavigation
} from '../BLTCommon/BLTNavigationTop'
import ApplicationStatus from '../BLTCommon/ApplicationStatus'
import { Button } from "../../../components/RegularComponents";
import { InformationDetailPanel } from "./InformationDetailPanel"
import { fetchApplicationWithIdAndSetStore } from "../../../redux/slice/collectionApplicationSlice";
import { setCurrentAgentApplicationId } from "../../../redux/slice/additionalApplicationsSlice";
import { 
    APPLICATION_STATUS_APPROVED_ISSUED,
    APPLICATION_STATUS_UNDER_REVIEW,
    APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
    APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
    LICENCE_STATUS_NEW,
} from "../../../app/constants";
import { fetchApplicationWithId } from "../../../redux/slice/bltHomeSlice";
import { setAgencyApplication } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { fullName } from "../../../app/utils";
import { applicationTypeFromLicenceSubType, isIndividualTypeApplication, isMortgageTypeApplication } from "../../../redux/slice/applicationsUtils";

const findAgentApplication = (agentApplications, currentAgentApplicationId) => {
    const found = agentApplications.find(agentApplication => agentApplication.id === currentAgentApplicationId);
    return found
}

function BLTInformationPage(props) {
    const { dispatch } = props
    let qItemId = useParams().qItemId;
    let tabKey = useParams().tabKey;
    let isArchiveApplication = false

    if (qItemId.indexOf("archiveId") === 0) {
        isArchiveApplication = true
        qItemId = qItemId.split("=")[1]
    }

    const [activeTabTitle, setActiveTabTitle] = useState("Information")
    const [showEditLicenceStatusTab, setShowEditLicenceStatusTab] = useState(false)

    const primaryAgencyApplication = useSelector(state => state.primaryAgencyApplication.application)
    const agentApplications = useSelector(state => state.additionalApplications.agentApplications)
    const currentAgentApplicationId = useSelector(state => state.additionalApplications.currentAgentApplicationId);

    const {licenceApplication, isAgencyApplication} = useMemo(() => {
        
        const licenceApplication = currentAgentApplicationId ? findAgentApplication(agentApplications, currentAgentApplicationId) : primaryAgencyApplication;
        return{
            licenceApplication: licenceApplication,
            isAgencyApplication: !currentAgentApplicationId
        } 
    }, [primaryAgencyApplication, agentApplications, currentAgentApplicationId])

    const statusParam = useMemo(() => {
        if(!licenceApplication) {
            return null
        }

        if(licenceApplication.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED
            && licenceApplication.licenceStatus 
            && licenceApplication.licenceStatus !== LICENCE_STATUS_NEW) 
        {
            return licenceApplication.licenceStatus
        }

        return licenceApplication.applicationStatus ?? APPLICATION_STATUS_UNDER_REVIEW
    }, [licenceApplication])

    // useEffect(() => {
    //     if(!primaryAgencyApplication) {
    //         dispatch(setCurrentAgentApplicationId(parseInt(qItemId)))
    //     }
    // }, [primaryAgencyApplication, qItemId, dispatch])

    useEffect(() => {
        
        const fetchLicenceApplication = async () => {
            dispatch(fetchApplicationWithIdAndSetStore(parseInt(qItemId), isArchiveApplication))
            .then(applicationData => {
                if(isIndividualTypeApplication(applicationData)) { 
                    if(applicationData.businessApplicationId > 0) {
                        dispatch(fetchApplicationWithId(applicationData.businessApplicationId, false, isArchiveApplication))
                            .then(mainApplication => {
                                if(mainApplication)
                                    dispatch(setAgencyApplication(mainApplication))
                            })
                    }
                        
                    dispatch(setCurrentAgentApplicationId(parseInt(applicationData.id)))
                }
                else {
                    //Unset cuurent agent application id if previously set.
                    dispatch(setCurrentAgentApplicationId(null))
                }
            })
        }

        fetchLicenceApplication()
    }, [dispatch, qItemId, isArchiveApplication])

    const handleEditLicenceStatus = () => {
        setActiveTabTitle("Edit licence")
        setShowEditLicenceStatusTab(true)
    }

    const appData = useMemo(() => {
        return licenceApplication ? licenceApplication.businessLicenceData : null;
    }, [licenceApplication])

    const typeOfContactString = useCallback(() => {
        if(!licenceApplication)
            return null
        const applicationType = applicationTypeFromLicenceSubType(licenceApplication.licencingSubType)
        if(isMortgageTypeApplication(applicationType)) {
            switch(applicationType) {
                case APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE: 
                    return "Principal Broker"
                case APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE: 
                    return "Mortgage Broker"
                case APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE: 
                    return "Mortgage Broker (Associate)"
                default : 
                    return "Broker"
            }
        }
        else if(applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE || 
                applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE)
            return "Compliance Officer"
        return "Business Contact"
    },[licenceApplication])

    const contactName = useMemo(() => {
        if(!primaryAgencyApplication || !licenceApplication)
            return null
        let businessContact = null
        const applicationType = applicationTypeFromLicenceSubType(licenceApplication.licencingSubType)
        if(isMortgageTypeApplication(applicationType)) {
            businessContact = licenceApplication.businessLicenceData?.personData
        } else {
            businessContact = primaryAgencyApplication.businessLicenceData?.mainBusinessContact
        }
        if (!businessContact) { return null }
        return `${fullName(businessContact)}, ${typeOfContactString()}`
    }, [primaryAgencyApplication, licenceApplication, typeOfContactString])
    
    if (!licenceApplication || !appData) {
        return null;
    }

    return (<>
        <BLTNavigationTop />
        <div className={"container"}>
            <BLTScreenNavigation {...props} />
            <div className="row">
                <div className="col">
                    <h1>{activeTabTitle}</h1>
                </div>
            </div>
            <div className="row ">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col">
                            <h2>{licenceApplication.name}</h2>
                            <h3>{appData?.companyRjscDetails?.businessData?.businessOwner ?? ""}</h3>
                            <span>{contactName}</span>
                        </div>
                        <div className="col-xs-10 col-lg-4" style={{ display: "flex", flexGrow: 1, gap: 12, alignItems: "center" }}>
                            <Button
                                id="edit-licence-status-button"
                                buttonType="regular_primary"
                                text="Edit licence status"
                                style={{ height: "3rem" }}
                                disabled={showEditLicenceStatusTab || isArchiveApplication}
                                onClick={handleEditLicenceStatus}
                            />
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                Current Status
                                <ApplicationStatus applicationStatus={statusParam} licenceStatus={licenceApplication?.licenceStatus}/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="row" style={{marginTop: "2rem"}}>
                <InformationDetailPanel 
                    licenceApplication={licenceApplication}
                    appData={appData}
                    setActiveTabTitle={setActiveTabTitle}
                    isAgencyApplication={isAgencyApplication}
                    showEditLicenceStatusTab={showEditLicenceStatusTab}
                    isArchiveApplication={isArchiveApplication}
                    hideEditLicenceStatusTab = {() => setShowEditLicenceStatusTab(false)}
                    activateTabKey={tabKey}
                />
            </div>
        </div>
    </>)
}

export default connect(bltReviewSelect)(BLTInformationPage)